import { useEffect, useState, useRef } from "react";
import moment from "moment";
import { getHours, getAfternoon, getUsers } from "../../services/newdaily";
import HorarioCalendar from "../../components/HorarioCalendar/HorarioCalendar";
import ViewSelector from "../../components/ViewSelector/ViewSelector";
import WeekSelector from "../../components/WeekSelector/WeekSelector";
import TurnSelector from "../../components/TurnSelector/TurnSelector";
import styles from "./ControlHorario.module.css";

import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import "overlayscrollbars/overlayscrollbars.css";
import { SpinnerComponent } from "../../components/Spinner";

const ControlHorario = ({ empleado, isAdmin }) => {
  const [tardes, setTardes] = useState([]);
  const [horasEmpleado, setHorasEmpleado] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState({ start: null, end: null });
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [loadedMonthKey, setLoadedMonthKey] = useState(null);
  const [usuarioActual, setUsuarioActual] = useState(null);

  const [isLoadingHours, setIsLoadingHours] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);

  const osRef = useRef(null);
  const [osViewport, setOsViewport] = useState(null);


  useEffect(() => {
    const fetchHoras = async () => {
      try {
        setIsLoadingHours(true);
        if (!empleado) return;

        const fechaParam = selectedDate || moment().format("YYYY-MM-DD");
        const wantedMonthKey = moment(fechaParam, "YYYY-MM-DD").format("YYYY-MM");

        if (loadedMonthKey === wantedMonthKey && horasEmpleado.length > 0) return;

        setLoadedMonthKey(wantedMonthKey);

        const data = await getHours({ empleado, fecha: fechaParam });
        setHorasEmpleado(Array.isArray(data) ? data : []);
      } catch (error) {
        console.error("Error al obtener horas del empleado:", error);
        setHorasEmpleado([]);
      } finally {
        setIsLoadingHours(false);
      }
    };

    fetchHoras();
  }, [empleado, selectedDate, loadedMonthKey]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoadingData(true);
        const [tardesData, usersData] = await Promise.all([
          getAfternoon(),
          getUsers(),
        ]);

        if (usersData?.Usuarios) {
        const user = usersData.Usuarios.find(
          (u) => String(u.id) === String(empleado)
        );
        setUsuarioActual(user || null);
      }

        if (tardesData?.Tardes && usersData?.Usuarios) {
          const idToNombre = {};
          usersData.Usuarios.forEach((user) => (idToNombre[user.id] = user.Nombre));

          setTardes(
            tardesData.Tardes.map((t) => ({
              ...t,
              Empleado: idToNombre[t.Empleado] || `${t.Empleado}`,
            }))
          );
        }
      } catch (error) {
        console.error("❌ Error al cargar datos:", error);
      } finally {
        setIsLoadingData(false);
      }
    };

    fetchData();
  }, [empleado]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.leftPanel}>
        {isLoadingHours ? <SpinnerComponent/> : (
        <HorarioCalendar
          tardes={tardes}
          isAdmin={isAdmin}
          selectedWeek={selectedWeek}
          onDateSelect={(newWeek) => setSelectedWeek(newWeek)}
          onDaySelect={(dateStr) => setSelectedDate(dateStr)}
        />
          )}
      </div>

      <div className={styles.rightPanel}>
        <div className={styles.headerContainer}>
          <ViewSelector />
          <WeekSelector
            onWeekChange={setSelectedWeek}
            externalWeek={selectedWeek}
          />

          {isLoadingData?
          <SpinnerComponent/> : (
          <div className={styles.turnContainer}>
            <OverlayScrollbarsComponent
              ref={osRef}
              options={{ scrollbars: { autoHide: "scroll", autoHideDelay: 300 } }}
              events={{
                initialized: (instance) => {
                  const vp = instance?.elements?.().viewport;
                  if (vp) setOsViewport(vp);
                },
                updated: (instance) => {
                  const vp = instance?.elements?.().viewport;
                  if (vp) setOsViewport(vp);
                },
              }}
              style={{ maxHeight: "100%", width: "100%" }}
            >
              <TurnSelector
                selectedWeek={selectedWeek}
                selectedDate={selectedDate}
                horasEmpleado={horasEmpleado}
                empleadoId={empleado}
                fechaEmpleado={usuarioActual?.Fecha_empleado ?? null}
                osViewport={osViewport}
              />
            </OverlayScrollbarsComponent>
          </div>
          )}
        </div>

        <div className={styles.contentContainer}></div>
      </div>
    </div>
  );
};

export default ControlHorario;
